export type PainelNotificationKind = 'info' | 'success' | 'warning' | 'review';

export type PainelNotification = {
  id: string;
  kind: PainelNotificationKind;
  title: string;
  message: string;
  /** Tempo relativo exibido na lista. */
  time: string;
  href?: string;
  read?: boolean;
};

export const PAINEL_MOCK_NOTIFICATIONS: PainelNotification[] = [
  {
    id: 'n1',
    kind: 'review',
    title: 'Guia aguardando revisão',
    message: '«Sistema de tickets do xat» foi enviado para aprovação.',
    time: 'Há 12 min',
    href: '/painel/guias',
  },
  {
    id: 'n2',
    kind: 'success',
    title: 'Power publicado',
    message: 'O power «Animate» está visível na Powerpédia.',
    time: 'Há 1 h',
    href: '/painel/powers',
  },
  {
    id: 'n3',
    kind: 'info',
    title: 'Novo membro na equipe',
    message: 'Paulo foi adicionado como Editor do painel.',
    time: 'Há 3 h',
    href: '/painel/usuarios',
  },
  {
    id: 'n4',
    kind: 'warning',
    title: 'Rascunho parado',
    message: '«Erros do xat» não é editado há 5 dias.',
    time: 'Ontem',
    href: '/painel/guias',
  },
  {
    id: 'n5',
    kind: 'info',
    title: 'Changelog atualizado',
    message: 'Versão 1.4.2 do xat foi registrada no changelog.',
    time: 'Há 2 dias',
    href: '/painel/changelog/xat/overview',
  },
  {
    id: 'n6',
    kind: 'success',
    title: 'Homepage guardada',
    message: 'Textos do hero e sugestões de pesquisa foram atualizados.',
    time: 'Há 4 dias',
    href: '/painel/paginas/homepage',
  },
];

export function countUnreadNotifications(items: PainelNotification[]): number {
  return items.filter((n) => !n.read).length;
}
